// import qs from 'qs'
import { withHeadersInstance } from './api-instance.js'
const baseUrl = process.env.VUE_APP_URL_API

export const GetProfile = async function() {
    try {
        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/user-profile`,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}

export const RemoveProfile = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/profile/remove`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
        return e.response.data
    }
}
